// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Field from "../layout-and-structure/Field.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as FontFaces from "../theme/FontFaces.res.js";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as LegacyIcon from "../images-and-icons/LegacyIcon.res.js";
import * as ReactAria from "react-aria";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactStately from "react-stately";
import * as ReactDomElement from "../../primitives/ReactDomElement.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
let buttonHeight = 40 / 2;
function borderColor(hovered, focused, errored) {
  if (focused && errored) {
    return "#b01745";
  } else if (!focused && errored) {
    return "#e61e5a";
  } else if (focused && !errored) {
    return "#a2a1b0";
  } else if (hovered && !focused && !errored) {
    return "#bdbdca";
  } else {
    return "#d7d7e0";
  }
}
function containerStyle(shrinkInput) {
  return {
    display: "inline-grid",
    gridTemplateAreas: `
      "input appender increment"
      "input appender decrement"
    `,
    gridTemplateColumns: (shrinkInput ? "0" : "1") + `fr 0fr auto`
  };
}
function inputStyle(strong, hovered, focused, disabled, stepper, appender, errored, placeholder) {
  return {
    backgroundColor: disabled ? "#f8f8fb" : "#fefefe",
    borderColor: borderColor(hovered && !disabled, focused, errored),
    borderStyle: "solid",
    borderRight: appender ? "none" : "auto",
    borderWidth: String(1) + "px",
    color: placeholder ? "#bdbdca" : "#25243a",
    fontFamily: FontFaces.fontFamilyFromFontName("LibreFranklin"),
    fontSize: String(15) + "px",
    fontWeight: strong ? "600" : "initial",
    height: String(40) + "px",
    minWidth: String(60) + "px",
    paddingLeft: "10px",
    width: String(100) + "%",
    zIndex: "1",
    borderRadius: stepper ? String(0) + "px" : String(5) + "px",
    borderTopLeftRadius: String(5) + "px",
    borderTopRightRadius: "0px",
    borderBottomLeftRadius: String(5) + "px",
    borderBottomRightRadius: "0px",
    flex: "1",
    boxSizing: "border-box",
    gridArea: "input"
  };
}
function appenderStyle(hovered, focused, disabled, stepper, errored) {
  return {
    backgroundColor: disabled ? "#f8f8fb" : "#fefefe",
    borderBottomColor: borderColor(hovered && !disabled, focused, errored),
    borderBottomRightRadius: stepper ? String(0) + "px" : String(5) + "px",
    borderBottomStyle: "solid",
    borderBottomWidth: "1px",
    borderLeftStyle: "none",
    borderLeftWidth: "0px",
    borderRightColor: borderColor(hovered && !disabled, focused, errored),
    borderRightStyle: "solid",
    borderRightWidth: "1px",
    borderTopColor: borderColor(hovered && !disabled, focused, errored),
    borderTopRightRadius: stepper ? String(0) + "px" : String(5) + "px",
    borderTopStyle: "solid",
    borderTopWidth: "1px",
    alignItems: "center",
    display: "flex",
    gridArea: "appender",
    justifyContent: "center",
    minWidth: "max-content",
    paddingLeft: "4px",
    paddingRight: "8px",
    paddingTop: String(1) + "px"
  };
}
function buttonStyle(hovered, focused, errored, pressed, disabled, mode) {
  return Object.assign({}, {
    backgroundColor: disabled || pressed ? "#f3f3f7" : "#fefefe",
    borderColor: borderColor(hovered && !disabled, focused, errored),
    borderStyle: "solid",
    borderWidth: String(1) + "px",
    cursor: disabled ? "default" : "pointer",
    display: "flex",
    marginLeft: String(-1) + "px",
    width: String(18) + "px",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box"
  }, mode === "increment" ? {
    borderBottomWidth: "0",
    height: String(buttonHeight) + "px",
    borderTopRightRadius: String(5) + "px",
    gridArea: "increment"
  } : {
    height: String(buttonHeight) + "px",
    borderBottomRightRadius: String(5) + "px",
    gridArea: "decrement"
  });
}
function appenderCurrency(currency) {
  return {
    TAG: "Currency",
    _0: currency
  };
}
function appenderCustom(custom) {
  return {
    TAG: "Custom",
    _0: custom
  };
}
let make = React.memo(props => {
  let onPress = props.onPress;
  let disabled = props.disabled;
  let mode = props.mode;
  let match = Hover.use(undefined, undefined, undefined);
  let hovered = match[1];
  let ref = match[0];
  let match$1 = React.useState(() => false);
  let setPressed = match$1[1];
  let match$2 = ReactAria.useButton(ReactAria.mergeProps(props.props, {
    elementType: "div",
    isDisabled: disabled,
    onPressStart: param => setPressed(param => true),
    onPressEnd: param => {
      setPressed(param => false);
      Stdlib_Option.forEach(onPress, x => x());
    }
  }), ref);
  let newrecord = {
    ...match$2.buttonProps
  };
  return JsxRuntime.jsx("div", (newrecord.style = buttonStyle(props.hovered || hovered, props.focused, props.errored, match$1[0], disabled, mode), newrecord.ref = Primitive_option.some(ref), newrecord.children = JsxRuntime.jsx(LegacyIcon.make, {
    name: mode === "increment" ? "arrow_up_light" : "arrow_down_light",
    fill: hovered ? disabled ? disabled ? "#bdbdca" : "#797885" : "#07061e" : disabled ? "#bdbdca" : "#797885",
    size: 12
  }), newrecord));
});
function InputNumberField$OptionalValue(props) {
  let __testLocalization = props.testLocalization;
  let onChange = props.onChange;
  let __allowsSideEffectChange = props.allowsSideEffectChange;
  let __useGrouping = props.useGrouping;
  let __hideStepper = props.hideStepper;
  let __strongStyle = props.strongStyle;
  let __disabled = props.disabled;
  let __required = props.required;
  let __focused = props.focused;
  let __autoFocused = props.autoFocused;
  let __shrinkInput = props.shrinkInput;
  let appender = props.appender;
  let placeholder = props.placeholder;
  let errorMessage = props.errorMessage;
  let label = props.label;
  let __precision = props.precision;
  let minPrecision = props.minPrecision;
  let maxValue = props.maxValue;
  let minValue = props.minValue;
  let value = props.value;
  let precision = __precision !== undefined ? __precision : 2;
  let shrinkInput = __shrinkInput !== undefined ? __shrinkInput : false;
  let autoFocused = __autoFocused !== undefined ? __autoFocused : false;
  let focused = __focused !== undefined ? __focused : false;
  let required = __required !== undefined ? __required : false;
  let disabled = __disabled !== undefined ? __disabled : false;
  let strongStyle = __strongStyle !== undefined ? __strongStyle : false;
  let hideStepper = __hideStepper !== undefined ? __hideStepper : false;
  let useGrouping = __useGrouping !== undefined ? __useGrouping : true;
  let allowsSideEffectChange = __allowsSideEffectChange !== undefined ? __allowsSideEffectChange : false;
  let testLocalization = __testLocalization !== undefined ? __testLocalization : I18n.locale;
  let match = React.useState(() => {
    if (autoFocused) {
      return true;
    } else {
      return focused;
    }
  });
  let setFocused = match[1];
  let focused$1 = match[0];
  let inputRef = React.useRef(null);
  let match$1 = Hover.use(inputRef, undefined, undefined);
  let hovered = match$1[1];
  let precision$1 = minPrecision !== undefined && minPrecision > precision ? minPrecision : precision;
  ReactUpdateEffect.use1(() => {
    setFocused(param => focused);
  }, [focused]);
  let formatOptions = React.useMemo(() => {
    if (focused$1 && precision$1 !== 0) {
      return {
        maximumFractionDigits: precision$1,
        useGrouping: useGrouping
      };
    }
    return {
      minimumFractionDigits: Stdlib_Option.getOr(minPrecision, precision$1),
      maximumFractionDigits: precision$1,
      useGrouping: useGrouping
    };
  }, [focused$1, precision$1]);
  let onChange$1 = React.useCallback(nextValue => {
    let handler = () => {
      if (value !== nextValue) {
        return onChange(isFinite(nextValue) ? nextValue : undefined);
      }
    };
    if (minValue !== undefined) {
      if (maxValue !== undefined) {
        if (nextValue >= minValue && nextValue <= maxValue) {
          return handler();
        } else {
          return;
        }
      } else if (nextValue >= minValue) {
        return handler();
      } else {
        return;
      }
    } else if (maxValue !== undefined && nextValue > maxValue) {
      return;
    } else {
      return handler();
    }
  }, [onChange, minValue, maxValue, value]);
  let onFocusChange = React.useCallback(value => setFocused(param => value), []);
  let props_defaultValue = focused$1 ? Stdlib_Option.orElse(value, NaN) : undefined;
  let props_value = !focused$1 ? Stdlib_Option.orElse(value, NaN) : undefined;
  let props_step = props.step;
  let props_formatOptions = formatOptions;
  let props_aria$label = Stdlib_Option.getOr(label, I18n.t("Numeric input field"));
  let props_isDisabled = disabled;
  let props_autoFocus = autoFocused;
  let props_onChange = onChange$1;
  let props_onFocus = props.onFocus;
  let props_onFocusChange = onFocusChange;
  let props_onBlur = props.onBlur;
  let props$1 = {
    locale: testLocalization,
    defaultValue: props_defaultValue,
    value: props_value,
    minValue: minValue,
    maxValue: maxValue,
    step: props_step,
    formatOptions: props_formatOptions,
    placeholder: placeholder,
    "aria-label": props_aria$label,
    isDisabled: props_isDisabled,
    autoFocus: props_autoFocus,
    onChange: props_onChange,
    onFocus: props_onFocus,
    onFocusChange: props_onFocusChange,
    onBlur: props_onBlur
  };
  let state = ReactStately.useNumberFieldState(props$1);
  let onKeyDown = React.useCallback((event, inputValue) => {
    let match = event.key;
    if (!focused$1) {
      return;
    }
    switch (match) {
      case ".":
        if (testLocalization === "fr-FR" && !inputValue.includes(",")) {
          return state.setInputValue(inputValue + ",");
        } else {
          return;
        }
      case "Enter":
        Stdlib_Option.map(ReactDomElement.fromRef(inputRef), domElement => {
          domElement.blur();
        });
        return;
      case "Escape":
        event.continuePropagation();
        return;
      default:
        return;
    }
  }, [focused$1, value]);
  let newrecord = {
    ...props$1
  };
  newrecord.onKeyDown = event => onKeyDown(event, state.inputValue);
  let props$2 = ReactAria.useNumberField(newrecord, state, inputRef);
  ReactUpdateEffect.useLayout1(() => {
    if (focused$1) {
      state.setInputValue(value !== undefined && isFinite(value) ? I18n.decimalFormat(testLocalization, formatOptions.minimumFractionDigits, formatOptions.maximumFractionDigits, useGrouping, value) : "");
    }
  }, [focused$1]);
  ReactUpdateEffect.use1(() => {
    let allowsSideEffectChange$1 = allowsSideEffectChange || focused$1;
    if (allowsSideEffectChange$1 && state.numberValue !== value && !Number.isNaN(state.numberValue)) {
      onChange$1(state.numberValue);
    }
  }, [state.numberValue]);
  ReactUpdateEffect.useLayout1(() => {
    if (!isFinite(state.numberValue)) {
      onChange(undefined);
    }
  }, [state.numberValue]);
  let inputProps = React.useMemo(() => ReactAria.mergeProps(props$2.inputProps, {
    placeholder: Stdlib_Option.getOr(placeholder, "")
  }), [props$2.inputProps, placeholder]);
  let inputStyle$1 = inputStyle(strongStyle, hovered, focused$1, disabled, !hideStepper, Stdlib_Option.isSome(appender), Stdlib_Option.isSome(errorMessage), value !== undefined ? value !== 0 || focused$1 ? Number.isNaN(value) : true : false);
  let value$1 = state.inputValue;
  let valueDecimal = value$1.includes(".") || value$1.includes(",");
  let valueLength = value$1.length - (valueDecimal ? 1 : 0);
  let inputStyle$2 = shrinkInput ? Object.assign({}, inputStyle$1, {
    minWidth: `calc(15px + ` + String(valueLength) + `ch)`
  }) : inputStyle$1;
  let appenderStyle$1 = appenderStyle(hovered, focused$1, disabled, !hideStepper, Stdlib_Option.isSome(errorMessage));
  let newrecord$1 = {
    ...Stylex.props(containerStyle(shrinkInput))
  };
  let newrecord$2 = {
    ...inputProps
  };
  let tmp;
  if (appender !== undefined) {
    let newrecord$3 = {
      ...Stylex.props(appenderStyle$1)
    };
    let tmp$1;
    tmp$1 = typeof appender !== "object" ? "%" : appender.TAG === "Currency" ? I18n.toCurrencySymbol(appender._0) : appender._0;
    newrecord$3.children = JsxRuntime.jsx(TextStyle.make, {
      children: tmp$1,
      size: "normal",
      opacity: 0.3
    });
    tmp = JsxRuntime.jsx("div", newrecord$3);
  } else {
    tmp = null;
  }
  newrecord$1.children = [JsxRuntime.jsx("input", (newrecord$2.style = inputStyle$2, newrecord$2.ref = Primitive_option.some(inputRef), newrecord$2)), tmp, hideStepper ? null : JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(make, {
      props: props$2.incrementButtonProps,
      mode: "increment",
      hovered: hovered,
      focused: focused$1,
      errored: Stdlib_Option.isSome(errorMessage),
      disabled: !state.canIncrement,
      onPress: () => {
        if (Number.isNaN(state.numberValue) || state.numberValue === 0) {
          return state.increment();
        }
      }
    }), JsxRuntime.jsx(make, {
      props: props$2.decrementButtonProps,
      mode: "decrement",
      hovered: hovered,
      focused: focused$1,
      errored: Stdlib_Option.isSome(errorMessage),
      disabled: !state.canDecrement
    })]
  })];
  return JsxRuntime.jsx(Field.make, {
    children: JsxRuntime.jsxs("div", newrecord$1),
    label: label,
    tooltip: props.tooltip,
    errorMessage: errorMessage,
    required: required
  });
}
let make$1 = React.memo(InputNumberField$OptionalValue);
let OptionalValue = {
  make: make$1
};
function InputNumberField(props) {
  let onChange = props.onChange;
  let __allowsSideEffectChange = props.allowsSideEffectChange;
  let __useGrouping = props.useGrouping;
  let __hideStepper = props.hideStepper;
  let __strongStyle = props.strongStyle;
  let __disabled = props.disabled;
  let __required = props.required;
  let __focused = props.focused;
  let __autoFocused = props.autoFocused;
  let __shrinkInput = props.shrinkInput;
  let __precision = props.precision;
  let value = props.value;
  let precision = __precision !== undefined ? __precision : 2;
  let shrinkInput = __shrinkInput !== undefined ? __shrinkInput : false;
  let autoFocused = __autoFocused !== undefined ? __autoFocused : false;
  let focused = __focused !== undefined ? __focused : false;
  let required = __required !== undefined ? __required : false;
  let disabled = __disabled !== undefined ? __disabled : false;
  let strongStyle = __strongStyle !== undefined ? __strongStyle : false;
  let hideStepper = __hideStepper !== undefined ? __hideStepper : false;
  let useGrouping = __useGrouping !== undefined ? __useGrouping : true;
  let allowsSideEffectChange = __allowsSideEffectChange !== undefined ? __allowsSideEffectChange : false;
  let onChange$1 = React.useCallback(nextValue => {
    if (nextValue !== undefined) {
      return onChange(nextValue);
    } else {
      return onChange(value);
    }
  }, [onChange, value]);
  return JsxRuntime.jsx(make$1, {
    value: value,
    minValue: props.minValue,
    maxValue: props.maxValue,
    step: props.step,
    minPrecision: props.minPrecision,
    precision: precision,
    label: props.label,
    tooltip: props.tooltip,
    errorMessage: props.errorMessage,
    placeholder: props.placeholder,
    appender: props.appender,
    shrinkInput: shrinkInput,
    autoFocused: autoFocused,
    focused: focused,
    required: required,
    disabled: disabled,
    strongStyle: strongStyle,
    hideStepper: hideStepper,
    useGrouping: useGrouping,
    allowsSideEffectChange: allowsSideEffectChange,
    onChange: onChange$1,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    testLocalization: props.testLocalization
  });
}
let make$2 = React.memo(InputNumberField);
let appenderPercent = "Percent";
export { appenderCurrency, appenderPercent, appenderCustom, OptionalValue, make$2 as make };
/* make Not a pure module */